import { type StateCreator, create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export type StoreCreatorWithMiddlewares<TState> = StateCreator<
  TState,
  [["zustand/devtools", never], ["zustand/immer", never]]
>;

export function createWithMiddlewares<TState>(
  createState: StoreCreatorWithMiddlewares<TState>
) {
  const slice = create<TState>()(devtools(immer(createState)));
  return slice;
}